import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobServiceWithErrorFeedback } from '@/core/services/report-job/abstract-report-job-error-feedback.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

export type OficioConfirmacaoJob = ReportJob;
export type OficioConfirmacaoJobStatus = JobStatus;

@Injectable({ providedIn: 'root' })
export class OficioConfirmacaoJobService extends AbstractReportJobServiceWithErrorFeedback {
    protected readonly sessionKey = 'oficio-confirmacao-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.oficioConfirmacao;
}
